import { type } from 'os';
import React, { useState,useEffect } from 'react';
import './index.less';
import {
    Input, Menu,
    Button,Table,Layout,
    Row,Col,Modal,
    Tag,
} from 'antd';
import {
    SearchOutlined,
    DownOutlined,
    PlusOutlined,
} from '@ant-design/icons';

interface IProps {
  children?: React.ReactElement | React.ReactElement[] | string
  className?: string
  GetAnalyses?: (param:string) => void
  onClick?: () => void
  placeholder?:string
  onChange?: (text) => void
}

export default function HeaderSearch(props: IProps = {
    placeholder:'Search'
}) {
    const [searchParam,setSearchParam] = useState<string>('');
    const {
        children,
        className,
        onClick,
        GetAnalyses,
        onChange
    } = props;
    const searchKeyDown = (e)=>{
        console.log(e.target.value);
        console.log(e);
        setSearchParam(e.target.value);
    };

    return (
        <h3 className={`soliHeader ${className}`} style={{maxWidth:400,position:'relative', display: 'inline-block'}}>
            <Input size="large"
                placeholder={props.placeholder}
                className='headerSearch'
                onBlur={(e:any)=>{
                    if(e.target?.value.length==0){
                        props.GetAnalyses('');
                    }
                }}
                onKeyUp = {(e:any)=>{
                    searchKeyDown(e);
                    // if(e.keyCode==13){
                    //     if(e.target?.value.length==0){
                    //         props.GetAnalyses('');
                    //     }
                    // }
                }}
                onChange={(e) => onChange(e.target?.value)}
                prefix={<SearchOutlined />}/>
            {/* <div>
                <Dropdown overlay={menu}>
                    <a
                        className="ant-dropdown-link"
                        onClick={e => e.preventDefault()}>
                        <Button type="link">
                            Show all <DownOutlined style={{fontSize:10}}/></Button></a>
                </Dropdown>
            </div> */}
            {searchParam.length>=0&&<Button
                type="default"
                style={{
                    position:'absolute',
                    top:9,
                    right:15,
                    zIndex:9,
                    background:'#59B948',
                    color:'#fff',
                    borderRadius:'4px'
                }}
                onClick={e=>{
                    props.GetAnalyses(searchParam);
                }}>
                Search
            </Button>}
        </h3>
    );
}